// import PageHeader from "../../components/masterlayout/PageHeader";
import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ClientContext } from "../../context/client/ClientContext";
import Common from "./common";

import { offerwallapi } from "../../config/axiosconfig";
import { LanguageContext } from "../../context/language/LanguageContext";
import { TenantContext } from "../../context/tenant/TenantContext";
import { Button, Modal, Spinner } from "react-bootstrap";
import { CardContext } from "../../context/card/CardContext";

export default function Account() {
    const navigate = useNavigate();
    const { client, clientdispatch } = useContext(ClientContext);
    const { carddispatch } = useContext(CardContext);

    const { language } = useContext(LanguageContext);
    const { tenant } = useContext(TenantContext);

    const chkEmailSubscription = useRef();
    const [showEmailSubscriptionConfirmModal, setShowEmailSubscriptionConfirmModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState("");

    const params = useParams();
    const tenanturl = params.tenanturlpathname;




    const breadcrumbs = [
        { label: "Home", path: "/" },
        { label: "Account Information", path: "/user/account" }, // Do not include the current page here
    ];


    useEffect(() => {
        if (tenant && client) {
            getEmailSubscription();
        }
    }, [tenant, client]);

    const getEmailSubscription = async () => {

        try {
            // console.log('im in')
            const clientobj = await offerwallapi.post("/api/cards/emailgetsubscription", {
                clientid: client.clientid,
                tenantid: tenant.tenantid,
            });

            // console.log('clientobj', clientobj)
            // chkEmailSubscription.current.checked = clientobj.isEmailSubscribed;
            chkEmailSubscription.current.checked = clientobj.data === 1;

        } catch (error) {
            console.log("OW-ERR-GETEMAILSUB: ", error)

        }
    }


    const emailSubscriptionConfirmModal = (e) => {
        if (!chkEmailSubscription.current.checked) {
            setShowEmailSubscriptionConfirmModal(true);
        } else {
            emailSubscription(1);
        }
    }
    const closeEmailSubscriptionConfirmModal = () => {
        setShowEmailSubscriptionConfirmModal(false);
    }
    const emailSubscription = async (isEmailSubscribed) => {
        setMessage("");
        setLoader(true);
        try {

            const clientobj = await offerwallapi.put("/api/cards/emailsubscription", {
                clientid: client.clientid,
                tenantid: tenant.tenantid,
                isemailsubscribed: isEmailSubscribed
            });

            //setMessage();
            // await setTimeout(() => { setLoader(false) }, 2000);
            //clientdispatch({ type: "CLIENT_SUCCESS", payload: clientobj.data });
            // clientdispatch({ type: "CLIENT_SUCCESS", payload: client });
            setShowEmailSubscriptionConfirmModal(false);
            setTimeout(() => { setLoader(false) }, 2000);
        } catch (error) {
            console.log("OW-ERR-EMAILSUB: ", error)
            setTimeout(() => { setLoader(false) }, 2000);
        }
    }

    const [newEmail, setNewEmail] = useState('')
    const [emailValidationMessage, setEmailValidationMessage] = useState('')

    const [showChangeEmail, setShowChangeEmail] = useState(false)
    const changeEmailAddress = async () => {
        setEmailValidationMessage("")
        setMessage("")
        const regexPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const isValid = regexPattern.test(newEmail);

        if (isValid) {
            setLoader(true);
            try {

                const clientobj = await offerwallapi.post("/api/clients/updateemail", {
                    clientid: client.clientid,
                    tenantid: tenant.tenantid,
                    newemail: newEmail,
                    newdisplayemail: newEmail.split("@")[0]
                });

                if (clientobj.data.code === "OWMS0005") {
                    setMessage(language?.error_res.error_l19);

                    setTimeout(() => { setLoader(false) }, 3000);
                } else {

                    setMessage(language?.success_res.success_l9);
                    const emailres = await offerwallapi.post("/api/clients/clientsignout", {
                        clientid: client.clientid,
                        tenantid: tenant.tenantid,
                    });
                    setTimeout(() => {
                        setShowChangeEmail(false)
                        setNewEmail('')
                        setEmailValidationMessage("")

                        clientdispatch({ type: "CLIENT_SIGNOUT" });
                        carddispatch({ type: "CARD_START" });

                        setLoader(false)
                        navigate(`/${tenanturl}`);
                    }, 5000);
                }


            } catch (error) {
                console.log("OW-ERR-CHANGE: ", error)
                setMessage(language?.error_res.error_l8);

                setTimeout(() => { setLoader(false) }, 3000);
            }
        } else {
            setEmailValidationMessage(language?.error_res.error_l1)
        }
    }



    return (
        <div className="col-md-9 border rounded-3">
            <div className="">
                <div className="isn-bradius bg-white p-4">
                    <h5 className="mb-4 fs-16">{language?.static_labels.myprofile}</h5>
                    <div>
                        <label className="text-uppercase text-secondary small fs-11">{language?.static_labels.emailaddress}</label>
                        <p className="text-dark fs-14">{client?.displayemail + "@" + client?.emailaddress.split("@")[1]}
                            <i class="bi bi-check-circle-fill text-success ms-2"></i>
                            {
                                tenant?.tenantmasterconfig.show_email_change ?
                                    <i class="bi bi-pencil-square ms-3" onClick={() => setShowChangeEmail(true)} title={language?.static_labels.change}></i>
                                    : ""
                            }
                        </p>
                    </div>
                    <div className="row">
                        {
                            showChangeEmail ?
                                <div className="mt-3 col-sm-12 col-md-6">
                                    <div class="input-group-t">
                                        <input onChange={e => setNewEmail(e.target.value)} value={newEmail} type="email" class="form-control mb-2"
                                            placeholder={language?.static_labels.enter_new_email} />
                                        <button class="btn btn-outline-primary me-2" type="button" onClick={changeEmailAddress}>{language?.static_labels.change}</button>
                                        <button class="btn btn-outline-secondary" type="button" onClick={() => {
                                            setShowChangeEmail(false);
                                            setNewEmail('');
                                            setEmailValidationMessage("")
                                        }}>{language?.static_labels.cancel}</button>
                                    </div>
                                    <p className="small text-danger">{emailValidationMessage}</p>
                                </div> : ""
                        }
                    </div>
                    <hr class="hr" />
                    <h5 className="mb-4 fs-16">
                        {language?.static_labels.emailsubscription}
                        <div class="form-check form-switch d-inline-block align-bottom ms-3">
                            <input class={`form-check-input`} type="checkbox"
                                ref={chkEmailSubscription} onChange={emailSubscriptionConfirmModal}
                                id="chkemailsubscription" />
                            <label class="form-check-label" for="chkemailsubscription"></label>
                        </div>
                    </h5>
                    <div>
                        <label className="text-secondary small fs-14">{language?.static_labels.email_subcription_desc}</label>
                    </div>
                </div>
            </div>
            <Modal show={showEmailSubscriptionConfirmModal}
                onHide={closeEmailSubscriptionConfirmModal} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{language?.card_enroll_labels.card_l9}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{language?.card_enroll_labels.card_l16}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeEmailSubscriptionConfirmModal}>
                        {language?.static_labels.no}
                    </Button>
                    <Button variant="primary" onClick={() => emailSubscription(0)}>
                        {language?.static_labels.yes}
                    </Button>
                </Modal.Footer>
            </Modal>

            {
                (loader) ? <div className="ow-full-overlay">
                    <div className="position-absolute ow-content-center text-center">
                        <Spinner animation="border" backdrop="static" variant="light" />
                        <h3 className="text-light">{message}</h3>
                    </div>
                </div>
                    : ""
            }
        </div>


    )

}